/*
创建者 魏强(2018.1.25)
精品速递
*/
<template>
<div class="home-module mb">
    <h3 class="module-title"><span>精品速递</span></h3>
    <div class="focus-warp">
        <div class="swipe-wrap" id="qua-swiper">
            <Carousel
		        v-model="value"
		        :autoplay="setting.autoplay"
		        :autoplay-speed="setting.autoplaySpeed"
		        :dots="setting.dots"
		        :radius-dot="setting.radiusDot"
		        :trigger="setting.trigger"
		        :arrow="setting.arrow"
		        >
		        <CarouselItem v-for="ch in list " :key="ch.aid">
		        	<div v-for="(item,index) in ch" :key="item.aid" class="qua-item">
			        	<router-link :to="item.url" target="_blank">
							<img class="img-item" :src="item.atturl" :alt="item.aname" />
					 	</router-link>
				 	</div>
		        </CarouselItem>
		    </Carousel>
        </div>
    </div>
</div>
</template>
<script>
export default {
	props:["data"],
	data() {
		let _list = this.data;
		let temp = [];
		for(let i=0,len=_list.length;i<len;i++){
			let index = parseInt(i/3);
			temp[index] = temp[index] || [];
			temp[index].push( _list[i] )
		}
	    return {
	        list : temp,
	         value: 0,
            setting: {
                autoplay: true,
                autoplaySpeed: 2000,
                dots: 'none',
                radiusDot: false,
                trigger: 'hover',
                arrow: 'hover'
            }
	    }
	}
}
</script>



// WEBPACK FOOTER //
// boutique.vue?c7e6879c